import * as React from 'react';
import {useCallback} from 'react';
import FileFetcher from 'src/js/fetchers/file_fetcher';

import styles from './FileDownload.less';

type Props = {
  downloadUrl: string;
  titleText: string | number;
};
export const FileDownload: React.FC<Props> = (props) => {
  const {downloadUrl, titleText, children} = props;
  const onClick = useCallback(() => {
    FileFetcher.downloadFile(downloadUrl);
  }, [downloadUrl]);
  return (
    <span data-name={'fileDownloadWrapper'}>
      <button
        type={'button'}
        className={styles.dlFileDownload}
        title={String(titleText ?? '')}
        onClick={onClick}
      >
        {children}
      </button>
    </span>
  );
};
